import { ChangeDetectorRef, Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { SessionService } from 'src/app/features/shared/services/Session.service';
import { PanelDetailTerritoriesService } from '../../../../services/Panel-Detail-Territories.service';
import { TerritoriesService } from '../../../../services/TerritoriesService.service';
import { MapHelperService } from 'src/services/map-helper.service';
import { PanelInternalLayerService } from 'src/app/features/map-features/sections/locations-section/services/Panel-Internal-Layer.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { ToastrService } from 'ngx-toastr';
import { UnileverService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/Unilever.service';
import { environment } from 'src/environments/environment.stage';
import { TerritoriesListItem, TerritoryDTO, TerritoryVirtualLocationsDTO } from '../../../../Models/TerritoriesListItem';
import { MatDialog } from '@angular/material/dialog';
import { PanelTerritoriesService } from '../../../../services/Panel-Territories.service';
import { TerritoryRouteTypeEnum } from '../../../../utilities/enums/TerritoriesEnum';

@Component({
  selector: 'territories-details-panel',
  templateUrl: './territories-details-panel.component.html',
  styleUrls: ['./territories-details-panel.component.css']
})
export class TerritoriesDetailsPanelComponent {
  selectedTerritory: TerritoryDTO;
  isStandAlone: boolean = false;
  public $Items: TerritoryVirtualLocationsDTO[];
  public $ItemsBackup: TerritoryVirtualLocationsDTO[];
  finder: string = "";
  
  public isLoading: boolean = true;
  filter: boolean = false;

  subscription_GetList: Subscription;
  subscription_getLoading: Subscription;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  fullScreen: boolean = false;

  // dummyData: LocationDTO[] = [
  //   { identifier: '30527886', description: 'Av. Juárez 123, Centro', cordsX: '-99.1332', cordsY: '19.4326' } as LocationDTO,
  //   { identifier: '30809551', description: 'Calle Reforma 456, Polanco', cordsX: '-99.1899', cordsY: '19.4340' } as LocationDTO,
  //   { identifier: '30809312', description: 'Insurgentes Sur 789, Roma', cordsX: '-99.1625', cordsY: '19.4200' } as LocationDTO,
  //   { identifier: '10650106', description: 'Av. Constituyentes 321, Lomas', cordsX: '-99.2500', cordsY: '19.4050' } as LocationDTO,
  //   { identifier: '30844315', description: 'Paseo de la Reforma 555, Chapultepec', cordsX: '-99.1837', cordsY: '19.4250' } as LocationDTO,
  // ];

  // dummyDataGeoJson = {
  //   "type": "FeatureCollection",
  //   "features": [
  //     // Puntos para FRJQ1_MON (5 esquinas del polígono)
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "30527886",
  //         "Description": "Esquina 1 - FRJQ1_MON",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJQ1_MON",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.1332, 19.4326]
  //       }
  //     },
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "30809551",
  //         "Description": "Esquina 2 - FRJQ1_MON",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJQ1_MON",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.1899, 19.4340]
  //       }
  //     },
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "30809312",
  //         "Description": "Esquina 3 - FRJQ1_MON",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJQ1_MON",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.2500, 19.4050]
  //       }
  //     },
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "10650106",
  //         "Description": "Esquina 4 - FRJQ1_MON",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJQ1_MON",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.1625, 19.4200]
  //       }
  //     },
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "30844315",
  //         "Description": "Esquina 5 - FRJQ1_MON",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJQ1_MON",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.1837, 19.4250]
  //       }
  //     },
  //     // Puntos para FRJQ2_MON (4 esquinas del polígono)
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "30527886",
  //         "Description": "Esquina 1 - FRJQ2_MON",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJQ2_MON",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.20, 19.40]
  //       }
  //     },
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "30809551",
  //         "Description": "Esquina 2 - FRJQ2_MON",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJQ2_MON",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.19, 19.40]
  //       }
  //     },
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "30809312",
  //         "Description": "Esquina 3 - FRJQ2_MON",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJQ2_MON",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.19, 19.41]
  //       }
  //     },
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "10650106",
  //         "Description": "Esquina 4 - FRJQ2_MON",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJQ2_MON",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.20, 19.41]
  //       }
  //     },
  //     // Puntos para FRJS_CEY (4 esquinas del polígono)
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "30527886",
  //         "Description": "Esquina 1 - FRJS_CEY",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJS_CEY",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.17, 19.40]
  //       }
  //     },
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "30809551",
  //         "Description": "Esquina 2 - FRJS_CEY",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJS_CEY",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.16, 19.40]
  //       }
  //     },
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "30809312",
  //         "Description": "Esquina 3 - FRJS_CEY",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJS_CEY",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.16, 19.41]
  //       }
  //     },
  //     {
  //       "type": "Feature",
  //       "properties": {
  //         "identifier": "10650106",
  //         "Description": "Esquina 4 - FRJS_CEY",
  //         "Icon": "bussineLocation.png",
  //         "idTerritory": "FRJS_CEY",
  //       },
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [-99.17, 19.41]
  //       }
  //     }
  //   ]
  // };

  // dummyGeoJson = {
  //   type: "FeatureCollection",
  //   features: [
  //     {
  //       type: "Feature",
  //       properties: { idTerritory: "FRJQ1_MON", saturation: 15, routeType: TerritoryRouteTypeEnum.Furia_Roja },
  //       geometry: {
  //         type: "Polygon",
  //         coordinates: [
  //           [
  //             [-99.1332, 19.4326],
  //             [-99.1899, 19.4340], 
  //             [-99.2500, 19.4050], 
  //             [-99.1625, 19.4200],
  //             [-99.1837, 19.4250], 
  //             [-99.1332, 19.4326] 
  //           ]
  //         ]
  //       }
  //     },
  //     {
  //       type: "Feature",
  //       properties: { idTerritory: "FRJQ2_MON", saturation: 90, routeType: TerritoryRouteTypeEnum.Reparto },
  //       geometry: {
  //         type: "Polygon",
  //         coordinates: [
  //           [
  //             [-99.20, 19.40],
  //             [-99.19, 19.40],
  //             [-99.19, 19.41],
  //             [-99.20, 19.41],
  //             [-99.20, 19.40]
  //           ]
  //         ]
  //       }
  //     },
  //     {
  //       type: "Feature",
  //       properties: { idTerritory: "FRJS_CEY", saturation: 40, routeType: TerritoryRouteTypeEnum.Preventa },
  //       geometry: {
  //         type: "Polygon",
  //         coordinates: [
  //           [
  //             [-99.17, 19.40],
  //             [-99.16, 19.40],
  //             [-99.16, 19.41],
  //             [-99.17, 19.41],
  //             [-99.17, 19.40]
  //           ]
  //         ]
  //       }
  //     }
  //   ]
  // };

  constructor(
    private sessionService: SessionService,
    private territoriesService: TerritoriesService,
    private panelDetailTerritoriesService: PanelDetailTerritoriesService,
    private mapHelperService: MapHelperService,
    changeDetectorRef: ChangeDetectorRef,
    private panelInternalLayerService: PanelInternalLayerService,
    media: MediaMatcher,
    private toastService: ToastrService,
    private unileverService: UnileverService,
    private matDialog: MatDialog,
    private panelTerritoriesService: PanelTerritoriesService
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 761px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.subscription_getLoading = this.panelDetailTerritoriesService.getLoading().subscribe((data: boolean) => {
        this.isLoading = data;
      });
  }

  ngOnInit(): void {
    this.panelDetailTerritoriesService.setLoading(true);
    // this.GetTerritories();
    // this.CreateLayers();
    this.getTerritoryLocationsList();
    this.checkingURL();
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy() {
    if (this.subscription_GetList) this.subscription_GetList.unsubscribe();
    if (this.subscription_getLoading)
      this.subscription_getLoading.unsubscribe();

    this.panelDetailTerritoriesService.destroyLayers();

    // if(this.isStandAlone){
    //   this.panelDetailTerritoriesService.destroyLayers();
    // }

    // this.panelDetailTerritoriesService.destroyLayers();
    //  this.panelTerritoriesService.toggleTerritoryLayers(true);
    // this.panelDetailTerritoriesService.removeFilters();
  }

  CreateLayers(){
    // this.panelDetailTerritoriesService.initializeLayers();
  }

  getTerritoryLocationsList() {
    const data = this.panelDetailTerritoriesService.getData();
    console.log("data detail", data);

    this.selectedTerritory = { 
      idTerritory: data.territoryItem.idTerritory,
      region: data.territoryItem.region,
      routeType: data.territoryItem.routeType,
      visitDay: data.territoryItem.visitDay,
      routeFrequency: data.territoryItem.routeFrequency,
      zone: data.territoryItem.zone,
      saturation: data.territoryItem.saturation
    } as TerritoryDTO;
  
    console.log("heeeelp selected territories", this. selectedTerritory);
      
  
    if (!environment.production) console.log("GetTerritoriesList", this.selectedTerritory);
      
    this.panelDetailTerritoriesService.setLoading(true);

    
    const finalLocationsGeoJson = {
      type: "FeatureCollection",
      features: []
    };

    const finalPolygonGeoJson = {
      type: "FeatureCollection",
      features: []
    };

    this.subscription_GetList = this.unileverService.GetPlanningTerritoriesDetails(this.selectedTerritory).subscribe((data: any) => {
      if (data[0].planningTerritoryDTO && data[0].geoJsonTerritory && data[0].geoJsonLocations) {
        const territoryDetails: TerritoryDTO = data[0].planningTerritoryDTO;

        this.$Items = territoryDetails.virtualLocationDTOs;
        this.$ItemsBackup = [...this.$Items];

        const territoryGeoJson = JSON.parse(data[0].geoJsonTerritory || '{}');

        // Si solo hay un punto, crear un polígono pequeño alrededor
        if (territoryGeoJson.features && territoryGeoJson.features.length === 1) {
          const singleFeature = territoryGeoJson.features[0];
          if (singleFeature.geometry && singleFeature.geometry.type === 'Point') {
            const [lng, lat] = singleFeature.geometry.coordinates;
            const offset = 0.001;

            const properties = singleFeature.properties || {
              saturation: this.selectedTerritory.saturation ? Number(this.selectedTerritory.saturation.replace("%", "")) : 0,
              routeType: this.selectedTerritory.routeType as TerritoryRouteTypeEnum,
              idTerritory: this.selectedTerritory.idTerritory,
              color: this.panelDetailTerritoriesService.assignColor(this.selectedTerritory.idTerritory)
            };

            // Crear un polígono cuadrado alrededor del punto
            const polygonFeature = {
              type: 'Feature',
              properties: { ...properties },
              geometry: {
                type: 'Polygon',
                coordinates: [[
                  [lng - offset, lat - offset],
                  [lng + offset, lat - offset],
                  [lng + offset, lat + offset],
                  [lng - offset, lat + offset],
                  [lng - offset, lat - offset]
                ]]
              }
            };

            territoryGeoJson.features = [polygonFeature];
          }
        }

        territoryGeoJson.features.forEach((feature: any) => {
          console.log("heeeeeeeeeeeelp terriotio", feature, territoryGeoJson);
          feature.properties = feature.properties || {};
          (feature.properties as any).saturation = this.selectedTerritory.saturation ? Number(this.selectedTerritory.saturation.replace("%", "")) : 0;
          (feature.properties as any).routeType = this.selectedTerritory.routeType as TerritoryRouteTypeEnum;
          (feature.properties as any).idTerritory = this.selectedTerritory.idTerritory;
          (feature.properties as any).color = this.panelDetailTerritoriesService.assignColor(this.selectedTerritory.idTerritory);
        });
        if (!environment.production) console.log(`Detalles del geoJson del territorio ${this.selectedTerritory.idTerritory}:`, territoryGeoJson);
        if (territoryGeoJson.features.length > 0)
          this.panelDetailTerritoriesService.loadMorePolygonGeoJson(territoryGeoJson);

        const locationsGeoJson = JSON.parse(data[0].geoJsonLocations || '{}');
        locationsGeoJson.features.forEach((feature: any) => {
          (feature.properties as any).idTerritory = this.selectedTerritory.idTerritory;
          (feature.properties as any).color = this.panelDetailTerritoriesService.assignColor(this.selectedTerritory.idTerritory);
        });
        if (!environment.production) console.log(`Detalles del geoJson de las ubicaciones del territorio ${this.selectedTerritory.idTerritory}:`, locationsGeoJson);
        if (locationsGeoJson.features.length > 0)
          this.panelDetailTerritoriesService.loadMoreLocationGeoJson(locationsGeoJson);

        finalLocationsGeoJson.features.push(...locationsGeoJson.features);
        finalPolygonGeoJson.features.push(...territoryGeoJson.features);
        
        this.mapHelperService.FitBounds(finalPolygonGeoJson);

      } else {
        console.error(`Error en los detalles del territorio ${this.selectedTerritory.idTerritory}:`, data[0].error);

      }


    this.panelDetailTerritoriesService.setLoading(false);
  });
  
  }

  // GetTerritoryLayer() {
  //   const selectedGeoJsonFeature = this.dummyGeoJson.features.find(feature => feature.properties.idTerritory === this.selectedTerritory.idTerritory) || this.dummyGeoJson.features[0];
  //   selectedGeoJsonFeature.properties.saturation = Number(this.selectedTerritory.saturation.replace("%", ""));
  //   selectedGeoJsonFeature.properties.routeType = this.selectedTerritory.routeType as TerritoryRouteTypeEnum;
  //   selectedGeoJsonFeature.properties.idTerritory = this.selectedTerritory.idTerritory;
  //   (selectedGeoJsonFeature.properties as any).color = this.panelDetailTerritoriesService.assignColor(this.selectedTerritory.idTerritory);
  //   const polygonGeoJson ={
  //     type: "FeatureCollection",
  //     features: [selectedGeoJsonFeature]
  //   }
  //   this.panelDetailTerritoriesService.loadMorePolygonGeoJson(polygonGeoJson);

  //   const dataGeoJsonFeatures = this.dummyDataGeoJson.features.filter(feature => feature.properties.idTerritory === this.selectedTerritory.idTerritory) || [...this.dummyDataGeoJson.features.filter(feature => feature.properties.idTerritory === "FRJQ1_MON")];
    
  //   dataGeoJsonFeatures.forEach(feature => {
  //     feature.properties.idTerritory = this.selectedTerritory.idTerritory;
  //     (feature.properties as any).color = this.panelDetailTerritoriesService.assignColor(this.selectedTerritory.idTerritory);
  //   });
  //   const pointGeoJson ={
  //     type: "FeatureCollection",
  //     features: dataGeoJsonFeatures
  //   }
  //   this.panelDetailTerritoriesService.loadMoreLocationGeoJson(pointGeoJson);
  //   // this.panelTerritoriesService.locationsGeoJson[this.selectedTerritory.idTerritory] = pointGeoJson;

  //   // this.panelDetailTerritoriesService.removeFilters();
  //   this.panelDetailTerritoriesService.addActiveTerritoryPolygonFilter(this.selectedTerritory.idTerritory);
  //   this.panelDetailTerritoriesService.addActiveTerritoryLocationFilter(this.selectedTerritory.idTerritory);
  //   this.mapHelperService.FitBounds(pointGeoJson);

  //   // if (this.panelInternalLayerService.capas.length > 0) {
  //   //   this.panelInternalLayerService.ActivateLayer(this.panelInternalLayerService.geofenceLayer);
  //   // } else {
  //   //   setTimeout(() => {
  //   //     this.panelInternalLayerService.ActivateLayer(this.panelInternalLayerService.geofenceLayer);
  //   //   }, 4000);
  //   // }
  // }

  checkingURL() {
    this.sessionService.CheckURLSource();
  }

  onFindTerritoryLocation(event) {
    this.panelDetailTerritoriesService.setLoading(true);
    if (!this.mobileQuery.matches) {
      this.fullScreen = true;
    }
    if (!environment.production) console.log(event);
    var texto = event.target ? event.target.value.toLowerCase() : this.finder.toLowerCase();
    if (texto.length == 0) {
      this.filter = false;
      this.$Items = this.$ItemsBackup;
      if (!environment.production) console.log("reset filter...");
      this.panelDetailTerritoriesService.setLoading(false);
    } else {
      this.filter = true;
      this.$Items = this.$ItemsBackup.filter((item) => {
        return (item.identifier.toLowerCase().includes(texto));
      });
      this.panelDetailTerritoriesService.setLoading(false);
    }
  }

  resetFilterValue() {
    this.finder = "";
    this.filter = false;
    this.$Items = this.$ItemsBackup;
    this.panelDetailTerritoriesService.setLoading(false);
  }

  onCardClicked(item: TerritoryVirtualLocationsDTO) {
    this.panelDetailTerritoriesService.openDetailsPopup(item.identifier, item.cordsX, item.cordsY);
  }

  removeLocation(item: TerritoryVirtualLocationsDTO) {
    this.$Items = this.$Items.filter(location => location !== item);
    this.$ItemsBackup = this.$ItemsBackup.filter(location => location !== item);
  }

  ClosePanel() {
    this.territoriesService.setVisiblePanelDetailTerritories(false);
  }

}
